import {Component, OnInit} from "@angular/core";
import {UserService} from "../services/users.service";
import {ActivatedRoute, Router} from "@angular/router";
import {UserDto} from "../../../models/user-dto";
import {HttpErrorResponse} from "@angular/common/http";
import {Auth2Service} from "../../../services/auth2.service";
import {ApiService} from "../../../services/api.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-create-edit-user',
  templateUrl: './create-edit-user.component.html',
  styleUrls: ['./create-edit-user.component.scss'],
  standalone: false
})
export class CreateEditUserComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Edit Profile'}
  ];

  showMessages: boolean = false;
  messages: any[] = [];

  showSuccessMessages: boolean = false;
  successMessages: any[] = [];

  statesList: any[] = [];
  causeDropdownList: any[] = [];

  profileName = 'Create Profile';
  savedUserId = '';
  savedUsername: string = '';
  savedPassword: string = '';
  savedFirstName: string = '';
  savedLastName: string = '';
  savedPhoneNumber: string = '';
  savedEmail: string = '';
  savedConfirmedEmail: string = '';
  savedEIN: string = '';
  savedCompanyName: string = '';
  //Physical Address for Square Integration
  savedAddressLine1: string = '';
  savedAddressLine2: string = '';
  savedAddressLine3: string = '';
  savedCity: string = '';
  savedState: string = '';
  savedCountry: string = '';
  savedZipCode: string = '';
  savedCause: string = '';
  savedAutoRenewalString: string = 'N';
  savedIsConsultingFlag: boolean = false;
  createFlag: boolean = true;
  termsAndConditionsObj: any = null;
  termsAndConditionsRadioButton: boolean = false;
  savedConsultantId: number = -1;
  savedConsultantEmail: string = "";
  savedConsultantReferralCode: string = "";
  savedConsultantReferralCodeVerified: string = "";
  savedConsultantRoleName: string = "";
  savedConsultantDisplayRoleName: string = "";

  consultantAutocomplete: any[] = [];
  inviteButtonClicked: boolean = false;

  grassrootsRadioButton: boolean = false;
  grassrootsRadioButtonFinal: boolean = false;
  grassrootsSubscriptionPlans: any[] = [];
  visionaryRadioButtonFinal: boolean = false;
  visionaryRadioButton: boolean = false;
  visionarySubscriptionPlans: any[] = [];
  trailblazerRadioButton: boolean = false;
  trailblazerRadioButtonFinal: boolean = false;
  trailblazerSubscriptionPlans: any[] = [];

  currentSubscriptionPlans: any[] = [];

  selectedSubscriptionPlan: any = null;

  savedAdditionalEmails: string[] = [];

  legalDocumentDisplayNameTemp: string = '';
  //legalDocumentTxtTemp: string = '';
  legalDocumentTxtList: string[] = [];
  username: string = '';

  registerBulkUsersWebUrl: string = '';
  requiresSignOutButton: boolean = true;

  consultantReadOnlyButton: boolean = true;
  consultantManagerButton: boolean = false;
  impersonatedEmail: any = null;
  consultantRoleName: any = null;

  isANonprofit: boolean = true;
  constructor(private userService: UserService,
              private router: Router,
              private route: ActivatedRoute,
              private auth2Service: Auth2Service,
              private apiService: ApiService,
              private titleService: Title) {
  }

  ngOnInit(): void {
    const broswerUrl: string = window.location.href;
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    //this.populateUSAStates();
    if (broswerUrl.includes('app/users/edit')) {
      this.titleService.setTitle("Scalanthropy Edit Profile");
      this.savedUserId = this.auth2Service.getUserId();
      this.username = this.auth2Service.getUsername();
      this.impersonatedEmail = this.auth2Service.getImpersonatedEmail();
      this.profileName = 'Edit Profile';
      // @ts-ignore
      this.userService.getUserProfile(this.username)
        .subscribe((result: any) => {
          if (result && result.body) {
            this.populateData(result.body)
            this.createFlag = false;
            this.userService.getApprovedConsultantsDropdown(this.username, this.impersonatedEmail).subscribe(
              (approvedConsultantsResponse: any) => {
              if (approvedConsultantsResponse && approvedConsultantsResponse.body) {
                this.consultantAutocomplete = approvedConsultantsResponse.body
              }
            }, (approvedConsultantsError: HttpErrorResponse) => {
                this.messages.push({
                  field: 'Get Approved Consultants Error',
                  detail: 'Failed to pull the list of approved consultants. Please refresh the page.',
                  severity: 'error'
                });
                this.showMessagesToUser();
              })
          }
        }, (error: HttpErrorResponse) => {
          if (error.status == 401) {
            this.messages.push({
              field: 'Get Profile Error',
              detail: 'You have logged out due to session being invalid. ' + error.error.message,
              severity: 'error'
            });
            this.showMessagesToUser();
            this.router.navigateByUrl('app/login');
          }
        })
    } else {
      this.titleService.setTitle("Scalanthropy Registration");
      this.breadCrumbs = [];
      this.requiresSignOutButton = false;
      this.populateCausesDropdown();
      this.populateCacheRegistrationData();
      const queryString = window.location.search;

      const urlParams = new URLSearchParams(queryString);
      // @ts-ignore
      let subscriptionPlanName: string = urlParams.get("subscriptionPlanName");
      if (!subscriptionPlanName) {
        subscriptionPlanName = 'GRASSROOTS_V4_SUBSCRIPTION_12_MONTH';
      }
      console.log(subscriptionPlanName);
      this.userService.getSubscriptionPricingV4ByPlanName(subscriptionPlanName)
        .subscribe((selSubPlanResult: any) => {
          if (selSubPlanResult && selSubPlanResult.body) {
            this.selectedSubscriptionPlan = selSubPlanResult.body;
            console.log("this.selectedSubscriptionPlan: " + this.selectedSubscriptionPlan);
          }
        }, (selSubPlanError: HttpErrorResponse) => {
          this.messages.push({
            field: 'Selected Subscription Plan Error',
            detail: 'Failed to load Subscription Plan or Subscription Plan does not exist. Please refresh. ',
            severity: 'error'
          });
          this.showMessagesToUser();
        });
      /*
      this.userService.getSubscriptionPricingBySubscriptionTypeV4("grassroots_v4")
        .subscribe((grassrootsResult: any) => {
          if (grassrootsResult && grassrootsResult.body) {
            this.grassrootsSubscriptionPlans = grassrootsResult.body;
          }
      }, (grassrootsError: HttpErrorResponse) => {
          this.messages.push({
            field: 'Grassroots Subscription Plans Error',
            detail: 'Failed to load Grassroots Subscription Plans. Please refresh. ',
            severity: 'error'
          });
          this.showMessagesToUser();
      });

      this.userService.getSubscriptionPricingBySubscriptionTypeV4("visionary_v4")
        .subscribe((visionaryResult: any) => {
          if (visionaryResult && visionaryResult.body) {
            this.visionarySubscriptionPlans = visionaryResult.body;
          }
      }, (visionaryError: HttpErrorResponse) => {
          this.messages.push({
            field: 'Visionary Subscription Plans Error',
            detail: 'Failed to load Visionary Subscription Plans. Please refresh. ',
            severity: 'error'
          });
          this.showMessagesToUser();
      });

      this.userService.getSubscriptionPricingBySubscriptionTypeV4("trailblazer_v4")
        .subscribe((trailblazerResult: any) => {
          if (trailblazerResult && trailblazerResult.body) {
            this.trailblazerSubscriptionPlans = trailblazerResult.body;
          }
      }, (trailblazerError: HttpErrorResponse) => {
          this.messages.push({
            field: 'Trailblazer Subscription Plans Error',
            detail: 'Failed to load Trailblazer Subscription Plans. Please refresh. ',
            severity: 'error'
          });
          this.showMessagesToUser();

      });*/

      /*
      this.userService.getConfig("REGISTER_BULK_USERS_WEB_URL").subscribe((configResult: any) => {
        if (configResult && configResult.body) {
          this.registerBulkUsersWebUrl = configResult.body.configValue;
        }
      }, (configError: HttpErrorResponse) => {
        this.messages.push({
          field: 'Need More Users Error',
          detail: 'Failed to load URL for requesting more users. ',
          severity: 'error'
        });
        this.showMessagesToUser();
      });*/

      this.userService.getTermsAndConditionsLegalDocument().subscribe((result2: any) => {
        if (result2 && result2.body) {
          this.termsAndConditionsObj = result2.body;
          this.legalDocumentDisplayNameTemp = this.termsAndConditionsObj.legalDocumentDisplayName;
          this.legalDocumentTxtList = this.termsAndConditionsObj.legalDocumentTxtList;
        }
      }, (err2: HttpErrorResponse) => {
        console.log('Error getting Terms and Conditions: ' + JSON.stringify(err2));
      });
    }
  }

  populateCausesDropdown(): void {
    this.userService.getCausesDropdown().subscribe((result: any) => {
      if (result && result.body) {
        this.causeDropdownList = result.body;
      }
    }, (error: HttpErrorResponse) => {
      this.messages.push({
        field: 'Failed to fetch the causes and giving interests',
        detail: 'Failed to fetch the causes and giving interests. Please refresh the page.',
        severity: 'error'
      });
      this.showMessagesToUser();
    });
  }
  toggleLegalAgreement(): void {
    this.termsAndConditionsRadioButton = !this.termsAndConditionsRadioButton;
  }

  toggleGrassrootsRadioButton(): void {
    this.grassrootsRadioButton = !this.grassrootsRadioButton;
    this.visionaryRadioButton = false;
    this.trailblazerRadioButton = false;
    if (!this.grassrootsRadioButton) {
      this.grassrootsRadioButtonFinal = false;
      this.currentSubscriptionPlans = [];
    } else {
      this.currentSubscriptionPlans = this.grassrootsSubscriptionPlans;
    }
  }

  toggleCurrentSubscriptionPlanRadioButtonFinal(index: number): void {
    const selectedSubscriptionPlan: any = this.currentSubscriptionPlans[index];
    selectedSubscriptionPlan["checked"] = !selectedSubscriptionPlan["checked"]

    let i: number = 0;
    for (const currentSubscriptionPlan of this.currentSubscriptionPlans) {
      if (i == index && currentSubscriptionPlan["checked"]) {
        if (currentSubscriptionPlan.subscriptionPlanName.includes("GRASSROOTS")) {
          this.grassrootsRadioButtonFinal = true;
          this.visionaryRadioButtonFinal = false;
          this.trailblazerRadioButtonFinal = false;
        } else if (currentSubscriptionPlan.subscriptionPlanName.includes("VISIONARY")) {
          this.grassrootsRadioButtonFinal = false;
          this.visionaryRadioButtonFinal = true;
          this.trailblazerRadioButtonFinal = false;
        } else if (currentSubscriptionPlan.subscriptionPlanName.includes("TRAILBLAZER")) {
          this.grassrootsRadioButtonFinal = false;
          this.visionaryRadioButtonFinal = false;
          this.trailblazerRadioButtonFinal = true;
        }
        i = i + 1;
        continue;
      } else if (i == index && !currentSubscriptionPlan["checked"]) {
        if (currentSubscriptionPlan.subscriptionPlanName.includes("VISIONARY") ||
          currentSubscriptionPlan.subscriptionPlanName.includes("TRAILBLAZER")) {
          this.grassrootsRadioButtonFinal = false;
          this.visionaryRadioButtonFinal = false;
          this.trailblazerRadioButtonFinal = false;
        }
        i = i + 1;
        continue;
      } else {
        currentSubscriptionPlan["checked"] = false;
        i = i + 1;
      }
    }
  }

  toggleVisionaryRadioButton(): void {
    this.visionaryRadioButton = !this.visionaryRadioButton;
    this.grassrootsRadioButton = false;
    this.trailblazerRadioButton = false;
    if (!this.visionaryRadioButton) {
      this.visionaryRadioButtonFinal = false;
      this.currentSubscriptionPlans = [];
    } else {
      this.currentSubscriptionPlans = this.visionarySubscriptionPlans;
    }
  }

  toggleTrailblazerRadioButton(): void {
    this.trailblazerRadioButton = !this.trailblazerRadioButton;
    this.grassrootsRadioButton = false;
    this.visionaryRadioButton = false;
    if (!this.trailblazerRadioButton) {
      this.trailblazerRadioButtonFinal = false;
      this.currentSubscriptionPlans = [];
    } else {
      this.currentSubscriptionPlans = this.trailblazerSubscriptionPlans;
    }
  }

  private populateCacheRegistrationData(): void {
    // @ts-ignore
    let firstName: string = localStorage.getItem("regFirstName");
    // @ts-ignore
    let lastName: string = localStorage.getItem("regLastName");
    // @ts-ignore
    let phoneNumber: string = localStorage.getItem("regPhoneNumber");
    // @ts-ignore
    let email: string = localStorage.getItem("regEmail");
    // @ts-ignore
    let confirmEmail: string = localStorage.getItem("regConfirmEmail");
    // @ts-ignore
    let ein: string =  localStorage.getItem("regEin");
    // @ts-ignore
    let companyName: string = localStorage.getItem("regCompanyName");
    // @ts-ignore
    let cause: string = localStorage.getItem("regCause");
    if (firstName) {
      this.savedFirstName = firstName;
    }

    if (lastName) {
      this.savedLastName = lastName;
    }

    if (email) {
      this.savedEmail = email;
      this.savedUsername = email;
    }

    if (phoneNumber) {
      this.savedPhoneNumber = phoneNumber;
    }
    if (ein) {
      this.savedEIN = ein;
    }

    if (companyName) {
      this.savedCompanyName = companyName;
    }

    if (cause) {
      this.savedCause = cause;
    }

    if (confirmEmail) {
      console.log(confirmEmail);
      this.savedConfirmedEmail = confirmEmail;
    }
  }

  private populateData(userDto: any) {
    if (userDto.userId) {
      this.savedUserId = userDto.userId;
    }

    if (userDto.firstName) {
      this.savedFirstName = userDto.firstName;
    }

    if (userDto.lastName) {
      this.savedLastName = userDto.lastName;
    }

    if (userDto.email) {
      this.savedEmail = userDto.email;
    }

    if (userDto.phoneNumber) {
      this.savedPhoneNumber = userDto.phoneNumber;
    }

    if (userDto.nonprofitDonorEin) {
      this.savedEIN = userDto.nonprofitDonorEin;
    }

    if (userDto.companyName) {
      this.savedCompanyName = userDto.companyName;
    }

    if (userDto.username) {
      this.savedUsername = userDto.username;
    }

    /*
    if (userDto.addressLine1) {
      this.savedAddressLine1 = userDto.addressLine1;
    }

    if (userDto.addressLine2) {
      this.savedAddressLine2 = userDto.addressLine2;
    }

    if (userDto.addressLine3) {
      this.savedAddressLine3 = userDto.addressLine3;
    }

    if (userDto.city) {
      this.savedCity = userDto.city;
    }

    if (userDto.state) {
      this.savedState = userDto.state;
      const stateEl = document.getElementById('usa-dropdown-list-id');
      // @ts-ignore
      stateEl.value = this.savedState;
    }

    if (userDto.country) {
      this.savedCountry = userDto.country;
    }

    if (userDto.zipCode) {
      this.savedZipCode = userDto.zipCode;
    }*/

    if (userDto.cause) {
      this.savedCause = userDto.cause;
    }

    if (userDto.consultantId) {
      this.savedConsultantId = userDto.consultantId;
    }

    if (userDto.consultantEmail) {
      this.savedConsultantEmail = userDto.consultantEmail;
    }

    if (userDto.consultantReferralCodeVerified) {
      this.savedConsultantReferralCodeVerified = userDto.consultantReferralCodeVerified;
    }

    if (userDto.consultantRoleName) {
      this.savedConsultantRoleName = userDto.consultantRoleName;
      this.consultantReadOnlyButton = true;
      this.consultantManagerButton = false;
      if (this.savedConsultantRoleName == 'READ_ONLY_ACCESS') {
        this.consultantReadOnlyButton = true;
        this.consultantManagerButton = false;
      } else if (this.savedConsultantRoleName == 'COLLABORATIVE_ACCESS') {
        this.consultantReadOnlyButton = false;
        this.consultantManagerButton = true;
      }
    }

    if (userDto.consultantDisplayRoleName) {
      this.savedConsultantDisplayRoleName = userDto.consultantDisplayRoleName;
    }
  }

  populateUSAStates(): void {
    this.statesList = [];
    this.userService.getUSAStatesDropdown().subscribe((result: any) => {
      if (result && result.body) {
        let i: number = 0;
        while (i < result.body.length) {
          this.statesList.push(result.body[i]);
          i = i + 1;
        }
      }
    }, (error: HttpErrorResponse) => {
      console.log(error);
    })
  }

  onCancel(): void {
    this.router.navigateByUrl(this.savedUserId ? 'app/users/dashboard' : 'app/login');
  }

  toggleIsANonprofitButton(): void {
    this.isANonprofit = !this.isANonprofit;
  }

  onSetUpTermsAndConditions(): any {
    // Get the modal
    var modal = document.getElementById("myModal");

    // Get the button that opens the modal
    // @ts-ignore
    var btn = document.getElementById("terms-and-conditions-alink-id");
    console.log('btn: ' + btn)

    // Get the <span> element that closes the modal
    var span: HTMLElement = document.getElementsByClassName("close")[0] as HTMLElement;
    // When the user clicks the button, open the modal
    // @ts-ignore
    btn.onclick = function() {
      // @ts-ignore
      modal.style.display = "block";
    }

    // When the user clicks on <span> (x), close the modal
    span.onclick = function() {
      // @ts-ignore
      modal.style.display = "none";
    }

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function(event) {
      if (event.target == modal) {
        // @ts-ignore
        modal.style.display = "none";
      }
    }
  }
  showMessagesToUser(delayTime: number = 8000): void {
    this.showMessages = true;
    const counterFn = () => {
      this.showMessages = false;
    }
    setTimeout(counterFn, delayTime);
  }

  showSuccessMessagesToUser(delayTime: number = 8000): void {
    this.showSuccessMessages = true;
    const counterFn = () => {
      this.successMessages = [];
      this.showSuccessMessages  = false;
    }
    setTimeout(counterFn, delayTime);
  }

  checkoutSessionV3(subscriptionPricePlan: any): void {
    this.messages = [];
    const promoCodeTxtEl = document.getElementById('promo-code-text-id');
    // @ts-ignore
    let promoCodeTxt: string = promoCodeTxtEl.value;

    this.userService.checkoutSessionV3(this.savedUsername, subscriptionPricePlan['subscriptionPlanName'], promoCodeTxt)
      .subscribe((result: any) => {
        if (result && result.body && result.body.url) {
          //Checkout Started
          this.successMessages.push({
            field: 'Checkout Session',
            detail: 'Checkout Session Started.',
            severity: 'success'
          });
          this.showMessagesToUser();
          // @ts-ignore
          window.open(result.body.url, '_self');
        }
      }, (err1: HttpErrorResponse) => {
        if (err1.status == 400) {
          this.messages.push({
            field: 'Subscription Plan Promo Code Error',
            detail: err1.error.message + '. Your account though has been created. Redirecting to subscription selection.',
            severity: 'error'
          });
        } else {
          this.messages.push({
            field: 'Subscription Plan Checkout Session API Error',
            detail: 'Failed to create a checkout session. ' + err1.error.message + ' Your account though has been created. Redirecting to subscription selection.',
            severity: 'error'
          });
        }
        this.showMessagesToUser(8000);
        //Redirect to Subscription payments and checkout.
        this.router.navigateByUrl('app/users/dashboard/subscription/pricing/pay');
      });
  }

  onSave(): void {
    this.showMessages = false;
    this.showSuccessMessages = false;
    this.messages = [];
    this.successMessages = [];
    //Validate First Name
    const firstNameEl = document.getElementById('first-name-text-id');
    // @ts-ignore
    let firstName = firstNameEl.value;
    if (!firstName) {
      this.messages.push({
        field: 'First Name',
        detail: 'First Name: ' + firstName + ' must not be empty.',
        severity: 'error'
      });
    }
    firstName = this.apiService.trimLeadingTrailingSpaces(firstName)
    if (firstName && firstName.length < 2 && firstName.length > 50) {
      this.messages.push({
        field: 'First Name',
        detail: 'First Name: ' + firstName + ' is not valid. The First Name must be 2 between 40 alphabetical characters, including dashes and spaces.',
        severity: 'error'
      })
    }
    this.savedFirstName = firstName;

    //Validate Last Name
    const lastNameEl = document.getElementById('last-name-text-id');
    // @ts-ignore
    let lastName = lastNameEl.value;
    if (!lastName) {
      this.messages.push({
        field: 'Last Name',
        detail: 'Last Name: ' + lastName + ' must not be empty.',
        severity: 'error'
      })
    }
    lastName = this.apiService.trimLeadingTrailingSpaces(lastName);
    if (lastName && lastName.length < 2 && lastName.length > 50) {
      this.messages.push({
        field: 'Last Name',
        detail: 'Last Name: ' + lastName + ' is not valid. The Last Name must be 2 between 40 alphabetical characters, including dashes and spaces.',
        severity: 'error'
      })
    }
    this.savedLastName = lastName;

    //Validate email
    const emailEl = document.getElementById('email-text-id');
    // @ts-ignore
    const email = emailEl.value;
    if (!email) {
      this.messages.push({
        field: 'Email',
        detail: 'Email: ' + email + ' is not valid.',
        severity: 'error'
      })
    }
    this.savedEmail = this.apiService.trimLeadingTrailingSpaces(email);

    if (this.createFlag) {
      const confirmEmailEl = document.getElementById('confirm-email-text-id');
      // @ts-ignore
      const confirmEmail = confirmEmailEl.value;
      if (!confirmEmail) {
        this.messages.push({
          field: 'Confirm Email',
          detail: 'Confirm Email: ' + email + ' is not valid.',
          severity: 'error'
        })
      } else if (this.savedEmail != confirmEmail) {
        this.messages.push({
          field: 'Email Mismatch',
          detail: 'Emails: do NOT is not match.',
          severity: 'error'
        })
      }
    }

    //Validate Phone Number
    const phoneNumberEl = document.getElementById('phone-number-text-id');
    // @ts-ignore
    const phoneNumber = phoneNumberEl.value;
    if (!phoneNumber) {
      this.messages.push({
        field: 'Phone Number',
        detail: 'Phone Number: ' + phoneNumber + ' must not be empty.',
        severity: 'error'
      })
    }
    let modPhoneNumber: string = phoneNumber.replaceAll("-", "");
    modPhoneNumber = modPhoneNumber.replaceAll(" ", "");
    modPhoneNumber = modPhoneNumber.replaceAll("(", "");
    modPhoneNumber = modPhoneNumber.replaceAll(")", "");
    if (modPhoneNumber && modPhoneNumber.length != 10) {
      this.messages.push({
        field: 'Phone Number',
        detail: 'Phone Number: ' + phoneNumber + ' is not valid. The Phone Number must be exactly 10 digits and must be a US phone number.',
        severity: 'error'
      })
    }
    this.savedPhoneNumber = modPhoneNumber;

    //Validate EIN
    if (this.createFlag && this.isANonprofit) {
      const einEl = document.getElementById('ein-text-id');
      // @ts-ignore
      const ein = einEl.value;
      if (!ein) {
        this.messages.push({
          field: 'EIN',
          detail: 'EIN: ' + ein + ' must not be empty. EIN must only be numbers and 9 digits in the following formats: XXXXXXXXX or XX-XXXXXXX.',
          severity: 'error'
        })
      }
      const einNoDash: string = ein.replace("-", "");
      if (einNoDash.length != 9) {
        this.messages.push({
          field: 'EIN',
          detail: 'EIN: ' + ein + ' is not valid. EIN must only be numbers and 9 digits in the following formats: XXXXXXXXX or XX-XXXXXXX.',
          severity: 'error'
        })
      }
      this.savedEIN = this.apiService.trimLeadingTrailingSpaces(einNoDash);
      this.savedCompanyName = 'ANY NONPROFIT';
    } else if (!this.createFlag)  {
      const einEl = document.getElementById('ein-text-id');
      // @ts-ignore
      const ein = einEl.value;
      if (!ein) {
        this.messages.push({
          field: 'EIN',
          detail: 'EIN: ' + ein + ' must not be empty. EIN must only be numbers and 9 digits in the following formats: XXXXXXXXX or XX-XXXXXXX.',
          severity: 'error'
        })
      }
      const einNoDash: string = ein.replace("-", "");
      if (einNoDash.length != 9) {
        this.messages.push({
          field: 'EIN',
          detail: 'EIN: ' + ein + ' is not valid. EIN must only be numbers and 9 digits in the following formats: XXXXXXXXX or XX-XXXXXXX.',
          severity: 'error'
        })
      }
      this.savedEIN = this.apiService.trimLeadingTrailingSpaces(einNoDash);
    }

    //Validate Company Name
    if (this.createFlag && !this.isANonprofit) {
      const companyNameEl = document.getElementById('company-name-text-id');
      // @ts-ignore
      const companyName = companyNameEl.value;
      if (!companyName) {
        this.messages.push({
          field: 'Company Name',
          detail: 'Company Name: ' + companyName + ' is not valid.',
          severity: 'error'
        })
      }
      this.savedEIN = '999999999';
      this.savedCompanyName = this.apiService.trimLeadingTrailingSpaces(companyName);
    } else if (!this.createFlag) {
      const companyNameEl = document.getElementById('company-name-text-id');
      // @ts-ignore
      const companyName = companyNameEl.value;
      if (!companyName) {
        this.messages.push({
          field: 'Company Name',
          detail: 'Company Name: ' + companyName + ' is not valid.',
          severity: 'error'
        })
      }
      this.savedCompanyName = this.apiService.trimLeadingTrailingSpaces(companyName);
    }

    //Validate Physical Address
    //Address Line 1
    /*
    const addressLine1El = document.getElementById('address-line-1-text-id');
    // @ts-ignore
    const addressLine1: string = addressLine1El.value;
    if (!addressLine1) {
      this.messages.push({
        field: 'AddressLine1',
        detail: 'AddressLine1: ' + addressLine1 + ' is not valid and must not be empty.',
        severity: 'error'
      })
    }
    this.savedAddressLine1 = this.apiService.trimLeadingTrailingSpaces(addressLine1);
    */
    this.savedAddressLine1 = 'N/A';
    /*
    const addressLine2El = document.getElementById('address-line-2-text-id');
    // @ts-ignore
    const addressLine2: string = addressLine2El.value;
    this.savedAddressLine2 = addressLine2*/
    this.savedAddressLine2 = 'N/A'

    //const addressLine3El = document.getElementById('address-line-3-text-id');
    // @ts-ignore
    const addressLine3: string = '';
    this.savedAddressLine3 = addressLine3;

    /*
    const cityEl = document.getElementById('city-text-id');
    // @ts-ignore
    const city = cityEl.value;
    if (!city) {
      this.messages.push({
        field: 'City',
        detail: 'City: ' + city + ' must not be empty.',
        severity: 'error'
      })
    }
    this.savedCity = this.apiService.trimLeadingTrailingSpaces(city);*/
    this.savedCity = 'N/A';

    /*
    const stateEl = document.getElementById('usa-dropdown-list-id');
    // @ts-ignore
    const state: string = stateEl.value;
    if (!state) {
      this.messages.push({
        field: 'State',
        detail: 'State: ' + state + ' must not be empty.',
        severity: 'error'
      })
    }
    this.savedState = this.apiService.trimLeadingTrailingSpaces(state);*/
    this.savedState = 'AR'

    /*
    const countryEl = document.getElementById('country-text-id');
    // @ts-ignore
    const country = countryEl.value;
    if (!country) {
      this.messages.push({
        field: 'Country',
        detail: 'Country: ' + country + ' must not be empty.',
        severity: 'error'
      })
    }
    this.savedCountry = this.apiService.trimLeadingTrailingSpaces(country);*/
    this.savedCountry = 'USA'

    /*
    const zipCodeEl = document.getElementById('zip-code-text-id');
    // @ts-ignore
    let zipCode: string = zipCodeEl.value;
    if (!zipCode) {
      this.messages.push({
        field: 'Zip Code',
        detail: 'Zip code: ' + zipCode + ' must not be empty.',
        severity: 'error'
      });
    } else {
      zipCode = zipCode.replace("-", "");
      zipCode = this.apiService.trimLeadingTrailingSpaces(zipCode)
      if (zipCode.length != 5 && zipCode.length != 9) {
        this.messages.push({
          field: 'Zip Code',
          detail: 'Zip code: ' + zipCode + ' can only be 5 digits or 9 digits.',
          severity: 'error'
        });
      }
    }
    this.savedZipCode = zipCode;*/
    this.savedZipCode = '99999';

    if (this.createFlag) {
      const causeEl = document.getElementById('cause-category-dropdown-list-id');
      // @ts-ignore
      const cause: string = causeEl.value;
      if (!cause) {
        this.messages.push({
          field: 'Cause',
          detail: 'Cause: ' + cause + ' must not be empty.',
          severity: 'error'
        })
      }
      this.savedCause = this.apiService.trimLeadingTrailingSpaces(cause);
    }

    this.savedAdditionalEmails = [];
    if (this.createFlag) {
      const emailRegex: RegExp = /^[a-z0-9\.\-_]+@[a-z0-9\-\.]+\.[a-z]{2,20}$/;
      //if (this.visionaryRadioButton && this.visionaryRadioButtonFinal) {
      if (this.selectedSubscriptionPlan['subscriptionPlanName'].includes("VISIONARY_V4")) {
        const visionaryAdditionalEmails1El = document.getElementById('visionary-additional-emails-1-text-id');
        // @ts-ignore
        const visionaryAdditionalEmails1Selected = visionaryAdditionalEmails1El.value;
        console.log("visionaryAdditionalEmails1Selected: " + visionaryAdditionalEmails1Selected);
        if (visionaryAdditionalEmails1Selected) {
          let cleanEmail1: string = this.apiService.trimLeadingTrailingSpaces(visionaryAdditionalEmails1Selected);
          let result: boolean = emailRegex.test(cleanEmail1)
          if (!result) {
            this.messages.push({
              field: 'Visionary Additional Email 1 Format Error',
              detail: 'Visionary Additional Email 1: ' + visionaryAdditionalEmails1Selected + ' is not a properly formatted email.',
              severity: 'error'
            });
          }
          this.savedAdditionalEmails.push(cleanEmail1);
        }
        const visionaryAdditionalEmails2El = document.getElementById('visionary-additional-emails-2-text-id');
        // @ts-ignore
        const visionaryAdditionalEmails2Selected = visionaryAdditionalEmails2El.value;
        if (visionaryAdditionalEmails2Selected) {
          let cleanEmail2: string = this.apiService.trimLeadingTrailingSpaces(visionaryAdditionalEmails2Selected);
          let result2: boolean = emailRegex.test(cleanEmail2)
          if (!result2) {
            this.messages.push({
              field: 'Visionary Additional Email 2 Format Error',
              detail: 'Visionary Additional Email 2: ' + visionaryAdditionalEmails2Selected + ' is not a properly formatted email.',
              severity: 'error'
            });
          }
          this.savedAdditionalEmails.push(cleanEmail2);
        }
        if (this.savedAdditionalEmails.length != 2) {
          this.messages.push({
            field: 'Visionary Additional Email',
            detail: 'Visionary Subscription Plan must have exactly 2 additional emails.',
            severity: 'error'
          });
        }
      } else if (this.selectedSubscriptionPlan['subscriptionPlanName'].includes("TRAILBLAZER_V4")) {
        const trailblazerAdditionalEmails1El = document.getElementById('trailblazer-additional-emails-1-text-id');
        // @ts-ignore
        const trailblazerAdditionalEmails1Selected = trailblazerAdditionalEmails1El.value;
        if (trailblazerAdditionalEmails1Selected) {
          let cleanEmail1: string = this.apiService.trimLeadingTrailingSpaces(trailblazerAdditionalEmails1Selected);
          let result: boolean = emailRegex.test(cleanEmail1)
          if (!result) {
            this.messages.push({
              field: 'Trailblazer Additional Email 1 Format Error',
              detail: 'Trailblazer Additional Email 1: ' + trailblazerAdditionalEmails1Selected + ' is not a properly formatted email.',
              severity: 'error'
            });
          }
          this.savedAdditionalEmails.push(cleanEmail1);
        }

        const trailblazerAdditionalEmails2El = document.getElementById('trailblazer-additional-emails-2-text-id');
        // @ts-ignore
        const trailblazerAdditionalEmails2Selected = trailblazerAdditionalEmails2El.value;
        if (trailblazerAdditionalEmails2Selected) {
          let cleanEmail2: string = this.apiService.trimLeadingTrailingSpaces(trailblazerAdditionalEmails2Selected);
          let result: boolean = emailRegex.test(cleanEmail2)
          if (!result) {
            this.messages.push({
              field: 'Trailblazer Additional Email 2 Format Error',
              detail: 'Trailblazer Additional Email 2: ' + trailblazerAdditionalEmails2Selected + ' is not a properly formatted email.',
              severity: 'error'
            });
          }
          this.savedAdditionalEmails.push(cleanEmail2);
        }

        const trailblazerAdditionalEmails3El = document.getElementById('trailblazer-additional-emails-3-text-id');
        // @ts-ignore
        const trailblazerAdditionalEmails3Selected = trailblazerAdditionalEmails3El.value;
        if (trailblazerAdditionalEmails3Selected) {
          let cleanEmail3: string = this.apiService.trimLeadingTrailingSpaces(trailblazerAdditionalEmails3Selected);
          let result: boolean = emailRegex.test(cleanEmail3)
          if (!result) {
            this.messages.push({
                field: 'Trailblazer Additional Email 3 Format Error',
                detail: 'Trailblazer Additional Email 3: ' + trailblazerAdditionalEmails3Selected + ' is not a properly formatted email.',
                severity: 'error'
            });
          }
          this.savedAdditionalEmails.push(cleanEmail3);
        }

          const trailblazerAdditionalEmails4El = document.getElementById('trailblazer-additional-emails-4-text-id');
          // @ts-ignore
          const trailblazerAdditionalEmails4Selected = trailblazerAdditionalEmails4El.value;
          if (trailblazerAdditionalEmails4Selected) {
            let cleanEmail4: string = this.apiService.trimLeadingTrailingSpaces(trailblazerAdditionalEmails4Selected);
            let result: boolean = emailRegex.test(cleanEmail4)
            if (!result) {
              this.messages.push({
                field: 'Trailblazer Additional Email 4 Format Error',
                detail: 'Trailblazer Additional Email 4: ' + trailblazerAdditionalEmails4Selected + ' is not a properly formatted email.',
                severity: 'error'
              });
            }
            this.savedAdditionalEmails.push(cleanEmail4);
          }

        if (this.savedAdditionalEmails.length != 4) {
          this.messages.push({
            field: 'Trailblazer Additional Email',
            detail: 'Trailblazer Subscription Plan must have exactly 4 additional emails.',
            severity: 'error'
          });
        }
      }
      //Check that email and all the savedAdditionalEmail are distinct.
      //1 for the root user
      //1-2 for the additional users
      if (this.savedAdditionalEmails.length > 0) {
        const distinctCheckObj: any = {};
        distinctCheckObj[this.savedEmail] = 0;
        for (const additionalEmail of this.savedAdditionalEmails) {
          distinctCheckObj[additionalEmail] = 0;
        }
        const result: boolean = Object.keys(distinctCheckObj).length == (this.savedAdditionalEmails.length + 1);
        if (!result) {
          this.messages.push({
            field: 'Additional Emails Uniqueness Error',
            detail: 'Ensure that the email and all the additional email are unique.',
            severity: 'error'
          });
        }
      }
    }

    let passwordEl = document.getElementById('password-text-id');
    // @ts-ignore
    let password = '';
    let repeatPasswordEl = document.getElementById('password-repeat-text-id');
    // @ts-ignore
    let repeatPassword = '';
    if (this.createFlag) {
      passwordEl = document.getElementById('password-text-id');
      // @ts-ignore
      password = passwordEl.value;

      repeatPasswordEl = document.getElementById('password-repeat-text-id');
      // @ts-ignore
      repeatPassword = repeatPasswordEl.value;
      if (password !== repeatPassword) {
        this.messages.push({
          field: 'password',
          detail: 'Passwords do NOT match.',
          severity: 'error'
        });
      }

      if (!this.termsAndConditionsRadioButton) {
        this.messages.push({
          field: 'Legal Agreement',
          detail: 'You must agree to the Terms and Conditions.',
          severity: 'error'
        });
      }
    }
    if (this.messages.length > 0 || (!this.termsAndConditionsRadioButton && this.createFlag)) {
      this.showMessagesToUser();
      return;
    }

    let userId = -1;
    if (this.savedUserId) {
      userId = parseInt(this.savedUserId);
    }

    let userDto: UserDto = {
      "userId": userId,
      "username": this.savedEmail,
      "password": password,
      "pwhash": '',
      "firstName": this.savedFirstName,
      "lastName": this.savedLastName,
      "phoneNumber": this.savedPhoneNumber,
      "email": this.savedEmail,
      "nonprofitDonorEin": this.savedEIN,
      "companyName": this.savedCompanyName,
      "isConsultant": 'N',
      "addressLine1": this.savedAddressLine1,
      "addressLine2": this.savedAddressLine2,
      "addressLine3": this.savedAddressLine3,
      "city": this.savedCity,
      "state": this.savedState,
      "country": this.savedCountry,
      "zipCode": this.savedZipCode,
      "additionalUsernames": this.savedAdditionalEmails,
      "cause": this.savedCause,
      "consultantId": this.savedConsultantId,
      "consultantEmail": this.savedConsultantEmail,
      "consultantReferralCode": this.savedConsultantReferralCode,
      "consultantReferralCodeVerified": this.savedConsultantReferralCodeVerified,
      "consultantRoleName": this.savedConsultantRoleName,
      "consultantDisplayRoleName": this.savedConsultantDisplayRoleName,
      "consultantAutoRenewal": "Y"
    }

    if (userId == -1) {
      //submit API
      this.successMessages.push({
        field: 'Account Creation',
        detail: 'Account (s) Creation Started. Please wait.',
        severity: 'success'
      });
      this.showSuccessMessages = true;
      this.userService.createUserProfileV3(userDto).subscribe((result: any) => {
        if (result && result.body) {
          //Account has been created successfully
          this.successMessages.push({
            field: 'Account Creation',
            detail: 'Account Successfully Created',
            severity: 'success'
          });
          localStorage.removeItem("regFirstName");
          localStorage.removeItem("regLastName");
          localStorage.removeItem("regPhoneNumber");
          localStorage.removeItem("regEmail");
          localStorage.removeItem("regConfirmEmail");
          localStorage.removeItem("regEin");
          localStorage.removeItem("regCompanyName");
          localStorage.removeItem("regCause");

          this.auth2Service.cacheSessionFull(result.body)
          //Submit Legal Agreement for records
          this.savedUsername = result.body.email;
          this.userService.createUserTermsAndConditionsLegalAgreement(this.savedUsername)
            .subscribe((result2: any) => {
              if (result2 && result2.body && result2.body.agreed ) {
                //Legal Agreement Recorded
                this.successMessages.push({
                  field: 'Legal Agreement',
                  detail: 'Legal Agreement Successfully Recorded.',
                  severity: 'success'
                });
                //Checkout URL Link Generation Started
                this.successMessages.push({
                  field: 'Checkout URL Link',
                  detail: 'Checkout URL Link Generation Started.',
                  severity: 'success'
                });

                //this.router.navigateByUrl('app/users/dashboard/subscription/pricing/pay');
                /*
                let i: number = 0
                let foundSubscriptionPlan: boolean = false;
                while (i < this.currentSubscriptionPlans.length) {
                  if (this.currentSubscriptionPlans[i].checked == true) {
                    foundSubscriptionPlan = true;
                    break;
                  }
                  i = i + 1;
                }
                if (foundSubscriptionPlan) {
                  this.checkoutSessionV3(this.currentSubscriptionPlans[i]);
                } else {
                  this.messages.push({
                    field: 'Checkout Generation of Link Failed',
                    detail: 'Failed to generate the checkout link. Redirecting to Subscription Pricing page since your account as been created.',
                    severity: 'error'
                  });
                  this.showMessagesToUser(4000);
                  this.router.navigateByUrl('app/users/dashboard/subscription/pricing/pay');
                }*/
                if (this.selectedSubscriptionPlan) {
                  this.checkoutSessionV3(this.selectedSubscriptionPlan);
                } else {
                  this.messages.push({
                    field: 'Checkout Generation of Link Failed',
                    detail: 'Failed to generate the checkout link. Redirecting to Subscription Pricing page since your account as been created.',
                    severity: 'error'
                  });
                  this.showMessagesToUser(4000);
                  this.router.navigateByUrl('app/users/dashboard/subscription/pricing/pay');
                }

              }
          }, (err2 : HttpErrorResponse) => {
              this.messages.push({
                field: 'username',
                detail: 'Error creating Agreement Entry for Terms and Conditions for username: ',
                severity: 'error'
              });
              this.showMessagesToUser();
            });
        }
      }, (err: HttpErrorResponse) => {
        const errorList: string[] = err.error.errors;
        let i: number = 0;
        while (i < errorList.length) {
          this.messages.push({
            field: 'Username Creation Error',
            detail: errorList[i],
            severity: 'error'
          });
          i = i + 1;
        }
        this.showMessagesToUser();
        this.successMessages = [];
        this.showSuccessMessages = false;
      });
    } else {
      //update user profile via API
      this.userService.updateUserProfile(userDto).subscribe((result: any) => {
        if (result && result.body) {
          this.router.navigateByUrl('app/users/dashboard');
        }
      }, (err: HttpErrorResponse) => {
        const errorList: string[] = err.error.errors;
        let i: number = 0;
        while (i < errorList.length) {
          this.messages.push({
            field: 'Username Update Error',
            detail: errorList[i],
            severity: 'error'
          });
          i = i + 1;
        }
        this.showMessagesToUser();
      });
    }
  }

  public saveInfoAndRedirectToPricingPage(): boolean {
    const firstNameEl = document.getElementById('first-name-text-id');
    // @ts-ignore
    let firstName = firstNameEl.value;

    const lastNameEl = document.getElementById('last-name-text-id');
    // @ts-ignore
    let lastName = lastNameEl.value;

    const phoneNumberEl = document.getElementById('phone-number-text-id');
    // @ts-ignore
    const phoneNumber = phoneNumberEl.value;

    const emailEl = document.getElementById('email-text-id');
    // @ts-ignore
    const email = emailEl.value;

    const confirmEmailEl = document.getElementById('confirm-email-text-id');
    // @ts-ignore
    const confirmEmail = confirmEmailEl.value;

    const einEl = document.getElementById('ein-text-id');
    let ein: string = '';
    if (einEl) {
      // @ts-ignore
      ein = einEl.value;
    }

    const companyNameEl = document.getElementById('company-name-text-id');
    let companyName: string = '';
    if (companyNameEl) {
      // @ts-ignore
      companyName = companyNameEl.value;
    }

    const causeEl = document.getElementById('cause-category-dropdown-list-id');
    // @ts-ignore
    const cause: string = causeEl.value;

    localStorage.setItem("regFirstName", firstName);
    localStorage.setItem("regLastName", lastName);
    localStorage.setItem("regPhoneNumber", phoneNumber);
    localStorage.setItem("regEmail", email);
    localStorage.setItem("regConfirmEmail", confirmEmail);
    localStorage.setItem("regEin", ein);
    localStorage.setItem("regCompanyName", companyName);
    localStorage.setItem("regCause", cause);
    window.location.href = 'https://www.scalanthropy.com/pricing';

    return true;
  }
}
